import React from "react";
import { ToolsNav } from "../nav";
import UsecaseHome from "./manager";
import { SectionTitle } from "@multiagentbook/ui";

export const UseCasesView = ({
  isComponent = true,
}: {
  isComponent?: boolean;
}) => {
  const pages = [
    { name: "Labs", href: "/labs", current: false },
    {
      name: "Use Cases",
      href: "/labs/usecases",
      current: true,
    },
  ];

  return (
    <>
      {!isComponent && <ToolsNav pages={pages} />}
      <div
        className={`  ${
          isComponent
            ? "border-t border-secondary mt-20 pt-20 my-10"
            : " my-20 "
        }`}
      ></div>

      <SectionTitle title="Multi-Agent Code Samples" />

      <UsecaseHome baseUrl="https://raw.githubusercontent.com/victordibia/multiagent-systems-with-autogen/refs/heads/main/course/" />
    </>
  );
};
